import { styled } from "styled-components";

export const DropdownButton = styled.button`
  width: 36px;
  height: 36px;
  background-color: white;
  font-size: 36px;
  font-weight: 600;

  border: 0px;
`;
